// import React, { useState, useEffect } from 'react';

// function EditProducts() {
//     const [isVisible, setIsVisible] = useState(false);
//     const [products, setProducts] = useState([]);
//     const [selectedProduct, setSelectedProduct] = useState("");
//     const [productName, setProductName] = useState("");
//     const [itemCode, setItemCode] = useState("");
//     const [category, setCategory] = useState("");
//     const [foodType, setFoodType] = useState("");
//     const [rate, setRate] = useState("");
//     const [Varients, setVarients] = useState([{ Varient: "", rate: "" }]);

//     useEffect(() => {
//         // Fetch product data from the backend
//         fetch("http://192.168.29.85:8888/RetreiveProduct")
//             .then((response) => response.json())
//             .then((ProData) => {
//                 // //(ProData); // Log the fetched products to console
//                 setProducts(ProData); // Set the fetched products in state
//             })
//             .catch((error) => console.error("Error fetching products:", error));
//     }, []);

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         if (name === "productName") setProductName(value);
//         else if (name === "itemCode") setItemCode(value);
//         else if (name === "category") setCategory(value);
//         else if (name === "foodType") setFoodType(value);
//         else if (name === "rate") setRate(value);
//     };

//     const handleVarientChange = (index, field, value) => {
//         const updatedVarients = Varients.map((Varient, i) => 
//             i === index ? { ...Varient, [field]: value } : Varient
//         );
//         setVarients(updatedVarients);
//     };

//     const handleAddVarient = () => {
//         setVarients([...Varients, { Varient: "", rate: "" }]);
//     };

//     const handleSubmit = async () => {
//         if (!productName || !itemCode || !category || !foodType) {
//             alert("Please fill in all fields.");
//             return;
//         }

//         const mainRate = Varients.length === 1 && Varients[0].Varient === "" ? rate : Varients[0].rate;

//         if (isNaN(mainRate) || mainRate === "") {
//             alert("Rate should not be empty or must be a number.");
//             return;
//         }

//         const data = {
//             statementType: "ProInsert",
//             productName,
//             itemCode,
//             category,
//             foodType,
//             rate: mainRate,
//             Varients: Varients.filter(v => v.Varient !== "")
//         };

//         // //(data);
//         try {
//             const response = await fetch("http://192.168.29.85:8888/ProductRegistration", {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json"
//                 },
//                 body: JSON.stringify(data)
//             });

//             if (response.ok) {
//                 // //("Data submitted successfully");
//                 setProductName("");
//                 setItemCode("");
//                 setCategory("");
//                 setFoodType("");
//                 setRate("");
//                 setVarients([{ Varient: "", rate: "" }]);
//             } else {
//                 console.error("Failed to submit data");
//             }
//         } catch (error) {
//             console.error("Error:", error);
//         }
//     };

//     return (
//         <div className='editProductMainDiv'>
//             <div className="editProductMainPartContentsCenterSide">
//                 <div className='editProductMainPartContentsDrop'>
//                     <div className="EmailProduct">
//                         <div className="EmailTextProduct">
//                             Products
//                         </div>
//                         <select
//                             className="InputEmailBox"
//                             name="products"
//                             type="text"
//                             value={selectedProduct}
//                             onChange={(e) => setSelectedProduct(e.target.value)}
//                         >
//                             <option value=""></option>
//                             {products.map((ProData) => (
//                                 <option key={ProData.Pro_id} value={ProData.Pro_id}>
//                                     {ProData.Pro_ItemName}
//                                 </option>
//                             ))}
//                         </select>
//                     </div>
//                 </div>
//                 <div className="editProductMainPartContentsCenterSideInside">
//                     <div className="editProductCenterSideHeadingDiv">
//                         Product Registration
//                     </div>
//                     <div className="editProductCenterSideHeadingNameDiv">
//                         <div className="editProductCenterSideHeadingName">
//                             Product Name
//                         </div>
//                         <input
//                             className="InputNameProduct"
//                             type="text"
//                             name="productName"
//                             value={productName}
//                             onChange={handleInputChange}
//                         />
//                     </div>
//                     <div className="AddressProduct">
//                         <div className="AddressTextProduct">
//                             Item Code
//                         </div>
//                         <input
//                             className="AddressInputBoxProduct"
//                             type="text"
//                             name="itemCode"
//                             value={itemCode}
//                             onChange={handleInputChange}
//                         />
//                     </div>
//                     <div className="EmailProduct">
//                         <div className="EmailTextProduct">
//                             Category
//                         </div>
//                         <select
//                             className="InputEmailBox"
//                             name="category"
//                             value={category}
//                             onChange={handleInputChange}
//                         >
//                             <option value="">Select Category</option>
//                             {products.map((ProData) => (
//                                 <option key={ProData.Pro_id} value={ProData.Pro_id}>
//                                     {ProData.Pro_Category}
//                                 </option>
//                             ))}
//                         </select>
//                     </div>
//                     <div className="MobProduct">
//                         <div className="MobTextProduct">
//                             Food Type
//                         </div>
//                         <select
//                             className="MobInputBox"
//                             name="foodType"
//                             value={foodType}
//                             onChange={handleInputChange}
//                         >
//                             <option value="">Select Category</option>
//                             <option value="Non Veg">Non-Veg</option>
//                             <option value="Veg">Veg</option>
//                         </select>
//                     </div>
//                     {Varients.length === 1 && Varients[0].Varient === "" ? (
//                         <div className="MobProduct">
//                             <div className="MobTextProduct">
//                                 Rate
//                             </div>
//                             <input
//                                 className="MobInputBox"
//                                 type="text"
//                                 name="rate"
//                                 value={rate}
//                                 onChange={handleInputChange}
//                             />
//                         </div>
//                     ) : (
//                         Varients.map((Varient, index) => (
//                             <div key={index} className="VarientInputContainer">
//                                 <div className="VarientTextProduct">Varient {index + 1}</div>
//                                 <input
//                                     className="VarientInputBoxProduct"
//                                     type="text"
//                                     name={`Varient_${index}`}
//                                     value={Varient.Varient}
//                                     onChange={(e) => handleVarientChange(index, 'Varient', e.target.value)}
//                                 />
//                                 <div className="MobTextProduct">Rate</div>
//                                 <input
//                                     className="VarientInputBoxProduct"
//                                     type="text"
//                                     name={`rate_${index}`}
//                                     value={Varient.rate}
//                                     onChange={(e) => handleVarientChange(index, 'rate', e.target.value)}
//                                 />
//                             </div>
//                         ))
//                     )}
//                     <div className="VarientText">
//                         <div className="VarientTextProduct">
//                             Varient Of Product
//                         </div>
//                         <button className="AddVarientButton" onClick={handleAddVarient}>+</button>
//                     </div>
//                     <div className="SumbitButtonProRegDiv">
//                         <button className="SubmitButtonProReg" onClick={handleSubmit}>
//                             Submit
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default EditProducts

// import React, { useState, useEffect } from 'react';
// import Select from 'react-select';

// function EditProduct() {
//     const [products, setProducts] = useState([]);
//     const [productName, setProductName] = useState("");
//     const [itemCode, setItemCode] = useState("");
//     // const [category, setCategory] = useState([]);
//     const [category, setCategory] = useState({ value: "", label: "" });
//     const [foodType, setFoodType] = useState("");
//     const [rate, setRate] = useState("");
//     const [Varients, setVarients] = useState([{ Varient: "", rate: "" }]);

//     useEffect(() => {
//         // Fetch product data from the backend
//         fetch("http://192.168.29.85:8888/RetreiveProduct")
//             .then((response) => response.json())
//             .then((ProData) => {
//                 // //(ProData); // Log the fetched products to console
//                 setProducts(ProData); // Set the fetched products in state
//             })
//             .catch((error) => console.error("Error fetching products:", error));
//     }, []);

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         if (name === "productName") setProductName(value);
//         else if (name === "itemCode") setItemCode(value);
//         else if (name === "rate") setRate(value);
//     };

//     const handleVarientChange = (index, field, value) => {
//         const updatedVarients = Varients.map((Varient, i) =>
//             i === index ? { ...Varient, [field]: value } : Varient
//         );
//         setVarients(updatedVarients);
//         // //(updatedVarients,"\nAll");
//     };

//     const handleAddVarient = () => {
//         setVarients([...Varients, { Varient: "", rate: "" }]);
//     };

//     const handleSubmit = async () => {
//         if (!productName || !itemCode || !category.length || !foodType) {
//             alert("Please fill in all fields.");
//             return;
//         }

//         const mainRate = Varients.length === 1 && Varients[0].Varient === "" ? rate : Varients[0].rate;

//         if (isNaN(mainRate) || mainRate === "") {
//             alert("Rate should not be empty or must be a number.");
//             return;
//         }

//         const data = {
//             statementType: "ProInsert",
//             productName: productName[0].Pro_ItemName,
//             itemCode : itemCode[0].Pro_ItemCode,
//             category: category[0].Pro_Category, // Extract the selected category
//             foodType: foodType[0].Pro_FoodType ,
//             rate: rate[0].Pro_Rate,
//             Varients: Varients.filter(v => v.Varient !== "")
//         };

//         // //(data);
//         try {
//             const response = await fetch("http://192.168.29.85:8888/ProductRegistration", {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json"
//                 },
//                 body: JSON.stringify(data)
//             });

//             if (response.ok) {
//                 // //("Data submitted successfully");
//                 setProductName([]);
//                 setItemCode([]);
//                 // setCategory([]);
//                 setCategory({ value: "", label: "" });
//                 setFoodType([]);
//                 setRate([]);
//                 setVarients([{ Varient: "", rate: "" }]);
//             } else {
//                 console.error("Failed to submit data");
//             }
//         } catch (error) {
//             console.error("Error:", error);
//         }
//     };

//     return (
//         <div className='editProductMainDiv'>
//             <div className="editProductMainPartContentsCenterSide">
//                 <div className='editProductMainPartContentsDrop'>
//                     <div className="EmailProduct">
//                         <div className="EmailTextProduct">
//                             Products
//                         </div>
//                         <Select
//                             className="InputEmailBox"
//                             name="products"

//                             options = {products.map((ProData) => ({
//                                 value: ProData.Pro_id,
//                                 label: ProData.Pro_ItemName,
                                
//                             }))}
//                             // value={products.find(product => product.Pro_ItemName === productName)}
//                             // onChange={(selectedOption) => setProductName(selectedOption ? selectedOption.label : "")
                            
//                             // }
//                             // placeholder="Type or select Products"
//                             // clearable
//                             // searchable
//                             value={products.find(product => product.Pro_ItemName === productName)}
//                             onChange={(selectedOption) => {
//                                 const product = products.find(p => p.Pro_id === selectedOption.value);
//                                 if (product) {
//                                     setProductName(product.Pro_ItemName);
//                                     setItemCode(product.Pro_ItemCode);
//                                     setCategory({ value: product.Pro_Category, label: product.Pro_Category });
//                                     setFoodType(product.Pro_FoodType);
//                                     setRate(product.Pro_Rate);
//                                     if (product.Varients && product.Varients.length > 0) {
//                                         setVarients(product.Varients);
//                                     } else {
//                                         setVarients([{ Varient: "", rate: "" }]);
//                                     }
//                                 }
//                             }}
//                             placeholder="Type or select Products"
//                             // isClearable   
//                             isSearchable
//                         />
//                     </div>
//                 </div>
//                 <div className="editProductMainPartContentsCenterSideInside">
//                     <div className="editProductCenterSideHeadingDiv">
//                         Product Registration
//                     </div>
//                     <div className="editProductCenterSideHeadingNameDiv">
//                         <div className="editProductCenterSideHeadingName">
//                             Product Name
//                         </div>
//                         <input
//                             className="InputNameProduct"
//                             type="text"
//                             name="productName"
//                             value={productName}
//                             onChange={handleInputChange}
//                         />
//                     </div>

//                     <div className="AddressProduct">
//                         <div className="AddressTextProduct">
//                             Item Code
//                         </div>
//                         <input
//                             className="AddressInputBoxProduct"
//                             type="text"
//                             name="itemCode"
//                             value={itemCode}
//                             onChange={handleInputChange}
//                         />
//                     </div>
//                     <div className="EmailProduct">
//                         <div className="EmailTextProduct">
//                             Category
//                         </div>
//                         {/* <Select
//                             className="InputEmailBox"
//                             options={products.map(product => ({
//                                 value: product.Pro_id,
//                                 label: product.Pro_Category
//                             }))}
//                             values={category}
//                             onChange={(value) => setCategory(value)}
//                             placeholder="Type or select category"
//                             clearable
//                             searchable
//                         /> */}
//                     </div>
//                     <div className="MobProduct">
//                         <div className="MobTextProduct">
//                             Food Type
//                         </div>
//                         <select
//                             className="MobInputBox"
//                             name="foodType"
//                             value={foodType}
//                             onChange={handleInputChange}
//                         >
//                             <option value="">Select Category</option>
//                             <option value="Non Veg">Non-Veg</option>
//                             <option value="Veg">Veg</option>
//                         </select>
//                     </div>
//                     {Varients.length === 1 && Varients[0].Varient === "" ? (
//                         <div className="MobProduct">
//                             <div className="MobTextProduct">
//                                 Rate
//                             </div>
//                             <input
//                                 className="MobInputBox"
//                                 type="text"
//                                 name="rate"
//                                 value={rate}
//                                 onChange={handleInputChange}
//                             />
//                         </div>
//                     ) : (
//                         Varients.map((Varient, index) => (
//                             <div key={index} className="VarientInputContainer">
//                                 <div className="VarientTextProduct">Varient {index + 1}</div>
//                                 <input
//                                     className="VarientInputBoxProduct"
//                                     type="text"
//                                     name={`Varient_${index}`}
//                                     value={Varient.Varient}
//                                     onChange={(e) => handleVarientChange(index, 'Varient', e.target.value)}
//                                 />
//                                 <div className="MobTextProduct">Rate</div>
//                                 <input
//                                     className="VarientInputBoxProduct"
//                                     type="text"
//                                     name={`rate_${index}`}
//                                     value={Varient.rate}
//                                     onChange={(e) => handleVarientChange(index, 'rate', e.target.value)}
//                                 />
//                             </div>
//                         ))
//                     )}
//                     <div className="VarientText">
//                         <div className="VarientTextProduct">
//                             Varient Of Product
//                         </div>
//                         <button className="AddVarientButton" onClick={handleVarientChange}>+</button>
//                     </div>
//                     <div className="SumbitButtonProRegDiv">
//                         <button className="SubmitButtonProReg" onClick={handleSubmit}>
//                             Submit
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default EditProduct;

// import React, { useState, useEffect } from 'react';
// import Select from 'react-select';

// function EditProduct() {
//     const [products, setProducts] = useState([]);
//     const [productName, setProductName] = useState("");
//     const [itemCode, setItemCode] = useState("");
//     const [category, setCategory] = useState({ value: "", label: "" });
//     const [foodType, setFoodType] = useState("");
//     const [rate, setRate] = useState("");
//     const [Varients, setVarients] = useState([{ Varient: "", rate: "" }]);

//     useEffect(() => {
//         // Fetch product data from the backend
//         fetch("http://192.168.29.85:8888/RetreiveProduct")
//             .then((response) => response.json())
//             .then((ProData) => {
//                 // //(ProData); // Log the fetched products to console
//                 setProducts(ProData); // Set the fetched products in state
//             })
//             .catch((error) => console.error("Error fetching products:", error));
//     }, []);

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         if (name === "productName") setProductName(value);
//         else if (name === "itemCode") setItemCode(value);
//         else if (name === "rate") setRate(value);
//     };

//     const handleVarientChange = (index, field, value) => {
//         const updatedVarients = Varients.map((Varient, i) =>
//             i === index ? { ...Varient, [field]: value } : Varient
//         );
//         setVarients(updatedVarients);
//     };

//     const handleAddVarient = () => {
//         setVarients([...Varients, { Varient: "", rate: "" }]);
//     };

//     const handleSubmit = async () => {
//         if (!productName || !itemCode || !category.value || !foodType) {
//             alert("Please fill in all fields.");
//             return;
//         }

//         const mainRate = Varients.length === 1 && Varients[0].Varient === "" ? rate : Varients[0].rate;

//         if (isNaN(mainRate) || mainRate === "") {
//             alert("Rate should not be empty or must be a number.");
//             return;
//         }

//         const data = {
//             statementType: "ProInsert",
//             productName,
//             itemCode,
//             category: category.value, // Extract the selected category
//             foodType,
//             rate: mainRate,
//             Varients: Varients.filter(v => v.Varient !== "")
//         };

//         // //(data);
//         try {
//             const response = await fetch("http://192.168.29.85:8888/ProductRegistration", {
//                 method: "POST",
//                 headers: {
//                     "Content-Type": "application/json"
//                 },
//                 body: JSON.stringify(data)
//             });

//             if (response.ok) {
//                 // //("Data submitted successfully");
//                 setProductName("");
//                 setItemCode("");
//                 setCategory({ value: "", label: "" });
//                 setFoodType("");
//                 setRate("");
//                 setVarients([{ Varient: "", rate: "" }]);
//             } else {
//                 console.error("Failed to submit data");
//             }
//         } catch (error) {
//             console.error("Error:", error);
//         }
//     };

//     return (
//         <div className='editProductMainDiv'>
//             <div className="editProductMainPartContentsCenterSide">
//                 <div className='editProductMainPartContentsDrop'>
//                     <div className="EmailProduct">
//                         <div className="EmailTextProduct">
//                             Products
//                         </div>
//                         <Select
//                             className="InputEmailBox"
//                             name="products"
//                             options={products.map((ProData) => ({
//                                 value: ProData.Pro_id,
//                                 label: ProData.Pro_ItemName,
//                             }))}
//                             value={products.find(product => product.Pro_ItemName === productName)}
//                             onChange={(selectedOption) => {
//                                 const product = products.find(p => p.Pro_id === selectedOption.value);
//                                 if (product) {
//                                     setProductName(product.Pro_ItemName);
//                                     setItemCode(product.Pro_ItemCode);
//                                     setCategory({ value: product.Pro_Category, label: product.Pro_Category });
//                                     setFoodType(product.Pro_FoodType);
//                                     setRate(product.Pro_Rate);
//                                     if (product.Varients && product.Varients.length > 0) {
//                                         setVarients(product.Varients);
//                                     } else {
//                                         setVarients([{ Varient: "", rate: "" }]);
//                                     }
//                                 }
//                             }}
//                             placeholder="Type or select Products"
//                             isSearchable
//                         />
//                     </div>
//                 </div>
//                 <div className="editProductMainPartContentsCenterSideInside">
//                     <div className="editProductCenterSideHeadingDiv">
//                         Product Registration
//                     </div>
//                     <div className="editProductCenterSideHeadingNameDiv">
//                         <div className="editProductCenterSideHeadingName">
//                             Product Name
//                         </div>
//                         <input
//                             className="InputNameProduct"
//                             type="text"
//                             name="productName"
//                             value={productName}
//                             onChange={handleInputChange}
//                         />
//                     </div>

//                     <div className="AddressProduct">
//                         <div className="AddressTextProduct">
//                             Item Code
//                         </div>
//                         <input
//                             className="AddressInputBoxProduct"
//                             type="text"
//                             name="itemCode"
//                             value={itemCode}
//                             onChange={handleInputChange}
//                         />
//                     </div>
//                     <div className="EmailProduct">
//                         <div className="EmailTextProduct">
//                             Category
//                         </div>
//                         {/* Update the category select input here */}
//                     </div>
//                     <div className="MobProduct">
//                         <div className="MobTextProduct">
//                             Food Type
//                         </div>
//                         <select
//                             className="MobInputBox"
//                             name="foodType"
//                             value={foodType}
//                             onChange={handleInputChange}
//                         >
//                             <option value="">Select Category</option>
//                             <option value="Non Veg">Non-Veg</option>
//                             <option value="Veg">Veg</option>
//                         </select>
//                     </div>
//                     {Varients.length === 1 && Varients[0].Varient === "" ? (
//                         <div className="MobProduct">
//                             <div className="MobTextProduct">
//                                 Rate
//                             </div>
//                             <input
//                                 className="MobInputBox"
//                                 type="text"
//                                 name="rate"
//                                 value={rate}
//                                 onChange={handleInputChange}
//                             />
//                         </div>
//                     ) : (
//                         Varients.map((Varient, index) => (
//                             <div key={index} className="VarientInputContainer">
//                                 <div className="VarientTextProduct">Varient {index + 1}</div>
//                                 <input
//                                     className="VarientInputBoxProduct"
//                                     type="text"
//                                     name={`Varient_${index}`}
//                                     value={Varient.Varient}
//                                     onChange={(e) => handleVarientChange(index, 'Varient', e.target.value)}
//                                 />
//                                 <div className="MobTextProduct">Rate</div>
//                                 <input
//                                     className="VarientInputBoxProduct"
//                                     type="text"
//                                     name={`rate_${index}`}
//                                     value={Varient.rate}
//                                     onChange={(e) => handleVarientChange(index, 'rate', e.target.value)}
//                                 />
//                             </div>
//                         ))
//                     )}
//                     <div className="VarientText">
//                         <div className="VarientTextProduct">
//                             Varient Of Product
//                         </div>
//                         <button className="AddVarientButton" onClick={handleAddVarient}>+</button>
//                     </div>
//                     <div className="SumbitButtonProRegDiv">
//                         <button className="SubmitButtonProReg"
//                         //  onClick={handleSubmit}
//                          >
//                             Submit
//                         </button>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }
// export default EditProduct;

import React, { useState, useEffect } from 'react';
import Select from 'react-select';

function EditProduct() {
    const [products, setProducts] = useState([]);
    const [productName, setProductName] = useState("");
    const [itemCode, setItemCode] = useState("");
    const [category, setCategory] = useState({ value: "", label: "" });
    const [foodType, setFoodType] = useState("");
    const [rate, setRate] = useState("");
    const [varieties, setVarieties] = useState([{ variety: "", rate: "" }]);
    const api_base_url = process.env.REACT_APP_API_BASE_URL
    const logginedDB   = localStorage.getItem('logginedDB') || 'HotelERP';

    useEffect(() => {
        // Fetch product data from the backend
        fetch(`${api_base_url}/RetreiveProduct/${logginedDB}`)
            .then((response) => response.json())
            .then((ProData) => {
                // //(ProData); // Log the fetched products to console
                setProducts(ProData); // Set the fetched products in state
            })
            .catch((error) => console.error("Error fetching products:", error));
    }, []);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === "productName") setProductName(value);
        else if (name === "itemCode") setItemCode(value);
        else if (name === "rate") setRate(value);
    };

    const handleVarietyChange = (index, field, value) => {
        const updatedVarieties = varieties.map((variety, i) =>
            i === index ? { ...variety, [field]: value } : variety
        );
        setVarieties(updatedVarieties);
    };

    const handleAddVariety = () => {
        setVarieties([...varieties, { variety: "", rate: "" }]);
    };

    const handleSubmit = async () => {
        if (!productName || !itemCode || !category.value || !foodType) {
            alert("Please fill in all fields.");
            return;
        }

        const mainRate = varieties.length === 1 && varieties[0].variety === "" ? rate : varieties[0].rate;

        if (isNaN(mainRate) || mainRate === "") {
            alert("Rate should not be empty or must be a number.");
            return;
        }

        const data = {
            statementType: "ProInsert",
            productName,
            itemCode,
            category: category.value,
            foodType,
            rate: mainRate,
            varieties: varieties.filter(v => v.variety !== "")
        };

        // //(data);
        try {
            const response = await fetch(`${api_base_url}/ProductRegistration/${logginedDB}`, {
                method: "POST",
                headers: { 
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(data)
            });

            if (response.ok) {
                // //("Data submitted successfully");
                setProductName("");
                setItemCode("");
                setCategory({ value: "", label: "" });
                setFoodType("");
                setRate("");
                setVarieties([{ variety: "", rate: "" }]);
            } else {
                console.error("Failed to submit data");
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    return (
        <div className='editProductMainDiv'>
            <div className="editProductMainPartContentsCenterSide">
                <div className='editProductMainPartContentsDrop'>
                    <div className="EmailProduct">
                        <div className="EmailTextProduct">
                            Products
                        </div>
                        <Select
                            className="InputEmailBox"
                            name="products"
                            options={products.map((ProData) => ({
                                value: ProData.Pro_id,
                                label: ProData.Pro_ItemName,
                            }))}
                            value={products.find(product => product.Pro_ItemName === productName) || null}
                            onChange={(selectedOption) => {
                                const product = products.find(p => p.Pro_id === selectedOption.value);
                                if (product) {
                                    setProductName(product.Pro_ItemName);
                                    setItemCode(product.Pro_ItemCode);
                                    setCategory({ value: product.Pro_Category, label: product.Pro_Category });
                                    setFoodType(product.Pro_FoodType);
                                    setRate(product.Pro_Rate);
                                    if (product.Varieties && product.Varieties.length > 0) {
                                        setVarieties(product.Varieties.map(v => ({
                                            variety: v.Varients,
                                            rate: v.Varients_Rate
                                        })));
                                    } else {
                                        setVarieties([{ variety: "", rate: "" }]);
                                    }
                                    // //("Selected product varieties:", product.Varieties);
                                }
                            }}
                            placeholder="Type or select Products"
                            isSearchable
                        />
                    </div>
                </div>
                <div className="editProductMainPartContentsCenterSideInside">
                    <div className="editProductCenterSideHeadingDiv">
                        Product Registration
                    </div>
                    <div className="editProductCenterSideHeadingNameDiv">
                        <div className="editProductCenterSideHeadingName">
                            Product Name
                        </div>
                        <input
                            className="InputNameProduct"
                            type="text"
                            name="productName"
                            value={productName}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div className="AddressProduct">
                        <div className="AddressTextProduct">
                            Item Code
                        </div>
                        <input
                            className="AddressInputBoxProduct"
                            type="text"
                            name="itemCode"
                            value={itemCode}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="EmailProduct">
                        <div className="EmailTextProduct">
                            Category
                        </div>
                        {/* Update the category select input here */}
                    </div>
                    <div className="MobProduct">
                        <div className="MobTextProduct">
                            Food Type
                        </div>
                        <select
                            className="MobInputBox"
                            name="foodType"
                            value={foodType}
                            onChange={handleInputChange}
                        >
                            <option value="">Select Category</option>
                            <option value="Non Veg">Non-Veg</option>
                            <option value="Veg">Veg</option>
                        </select>
                    </div>
                    {varieties.length === 1 && varieties[0].variety === "" ? (
                        <div className="MobProduct">
                            <div className="MobTextProduct">
                                Rate
                            </div>
                            <input
                                className="MobInputBox"
                                type="text"
                                name="rate"
                                value={rate}
                                onChange={handleInputChange}
                            />
                        </div>
                    ) : (
                        varieties.map((variety, index) => (
                            <div key={index} className="VarietyInputContainer">
                                <div className="VarietyTextProduct">Variety {index + 1}</div>
                                <input
                                    className="VarietyInputBoxProduct"
                                    type="text"
                                    name={`variety_${index}`}
                                    value={variety.variety}
                                    onChange={(e) => handleVarietyChange(index, 'variety', e.target.value)}
                                />
                                <div className="MobTextProduct">Rate</div>
                                <input
                                    className="VarietyInputBoxProduct"
                                    type="text"
                                    name={`rate_${index}`}
                                    value={variety.rate}
                                    onChange={(e) => handleVarietyChange(index, 'rate', e.target.value)}
                                />
                            </div>
                        ))
                    )}
                    <div className="VarietyText">
                        <div className="VarietyTextProduct">
                            Variety Of Product
                        </div>
                        <button className="AddVarietyButton" onClick={handleAddVariety}>+</button>
                    </div>
                    <div className="SumbitButtonProRegDiv">
                        <button className="SubmitButtonProReg" onClick={handleSubmit}>
                            Submit
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default EditProduct;
